// Imports => Vendor
import axios from 'axios';

// Imports => MOBX
import { makeObservable, observable, computed, action } from 'mobx';

// Imports => Constants
import {AcIsArray, KEYS} from '@opp/ui-kit';

// Imports => Utilities
import {
  AcSaveState,
  AcRemoveState,
  AcIsSet,
  AcIsNull,
  AcIsUndefined,
  AcFormatErrorMessage,
  AcFormatErrorCode,
} from '@opp/ui-kit';
import { AcAutoLoad, AcAutoSave } from '@utils';

const _default = {
  compliance_requirements: null,
};

let app = {};

export class ComplianceRequirementsStore {
  constructor(store) {
    makeObservable(this);

    AcAutoSave(this);

    app.store = store;
  }

    @observable
      compliance_requirements = _default.compliance_requirements;

    @computed
    get current_compliance_requirements() {
      return this.compliance_requirements;
    }

    @computed
    get current_unverified_compliance_requirements() {
      if (!this.compliance_requirements || !AcIsArray(this.compliance_requirements))
        return [];
      return this.compliance_requirements.filter(
        (item) => item.status === 'unverified'
      );
    }

    @computed
    get current_pending_compliance_requirements() {
      if (!this.compliance_requirements || !AcIsArray(this.compliance_requirements))
        return [];
      return this.compliance_requirements.filter(
        (item) => item.status === 'pending'
      );
    }

    @observable
      loading = {
        status: false,
        message: null,
      };

    @computed
    get is_loading() {
      return this.loading.status;
    }

    @action
      setLoading = (state, message) => {
        this.loading = {
          status: state || false,
          message,
        };
      };

    @observable
      busy = {
        status: false,
        message: null,
      };

    @computed
    get is_busy() {
      return this.busy.status;
    }

    @action
      setBusy = (state, message) => {
        this.busy = {
          status: state || false,
          message,
        };
      };

    @action
      list_compliance_requirements = (t) => {
        this.setLoading(true);

        return app.store.api.compliance_requirements
          .list_compliance_requirements({ perpage: 100 })
          .then(async (response) => {
            await this.set(KEYS.COMPLIANCE_REQUIREMENTS, response);

            this.setLoading(false);

            return response;
          })
          .catch((error) => {
            if (!axios.isCancel(error)) {
              app.store.toasters.add({
                variant: 'error',
                title: t('compliance-requirements.failed-to-retrieve', {ns: 'store'}),
                description: AcFormatErrorMessage(error),
                code: AcFormatErrorCode(error),
              });
            }

            this.setLoading(false);

            if (!axios.isCancel(error)) throw error;
          });
      };

    @action
      set = (target, value, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;
        if (AcIsUndefined(value)) return;

        return new Promise((resolve) => {
          this[target] = value;
          if (save) AcSaveState(target, value);
          resolve();
        });
      };

    @action
      setState = (target, property, value, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;
        if (!AcIsSet(property)) return;
        if (AcIsUndefined(value)) return;

        this[target][property] = value;
        if (save) AcSaveState(target, value);
      };

    @action
      reset = (target, save = false) => {
        if (!AcIsSet(target)) return;
        if (AcIsUndefined(this[target])) return;

        return new Promise((resolve) => {
          this[target] = _default[target];
          if (save && AcIsNull(_default[target])) {
            AcRemoveState(target);
          } else if (save) {
            AcSaveState(target, _default[target]);
          }

          resolve();
        });
      };
}

export default ComplianceRequirementsStore;
